module.exports = __webpack_public_path__ + "img/IMG_3539_L_Black.6e360da1.jpg";